export class TraceError {
  responseCode: string;
  responseMessage: string;
}
